import { HttpException } from "http-repository-cache";
import RequestsRepository from "@/core/requests/repositories/RequestsRepository";
import {
  RequestFilters,
  REQUESTS,
  RequestType,
  SEGMENTS,
} from "@/core/requests/entities/RequestTypes";
import {
  CreateProspectRequest,
  CreateProspectResponse,
  PmCountryEligibility,
  ReferenceOption,
} from "@/core/requests/entities/Prospect";
import ProspectDataMapper, {
  ApiProspectRequest,
  ApiCreateProspectRequest,
} from "@/core/requests/mappers/ProspectDataMapper";
import {
  //   getRequestsUrl,
  //   getSegmentsUrl,
  createProspectUrl,
  generateAccessUrl,
  incorporationCountriesUrl,
  legalFormsForCountryUrl,
  //   filterRequestsUrl,
} from "../../api/requestsBackendEndpoints/requestsBackendEndpoints";
import handleRequestError from "../../http/services/handleRequestError/handleRequestError";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import {
  RepositoryResult,
  RepositoryResultFactory,
} from "core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { GenerateAccessResponse } from "@/core/requests/entities/generateAccess";

interface ApiCountryItem {
  // codeBni = code RIC/CBS (272 pour CI). C'est LA clé pays de tout le module KYB
  // (kyb_country_scope, kyb_ref_version, LegalEntityBlock.incorporationCountryCode) —
  // codeIso2 n'est jamais accepté par ces endpoints, malgré une doc historique erronée
  // qui laissait croire le contraire.
  codeBni?: string | null;
  nom?: string | null;
}

interface ApiCountriesPage {
  items?: ApiCountryItem[] | null;
}

interface ApiLegalFormOption {
  code: string;
  libelle: string;
}

/** Reponse enrichie renvoyee par POST /customers/prospect pour segment=PM uniquement. */
interface ApiProspectCreateResponse {
  businessKey: string;
}

interface ApiPmCountryEligibility {
  countryCode: string;
  available: boolean;
  reason: PmCountryEligibility["reason"];
  message: string;
  legalForms?: ApiLegalFormOption[] | null;
}

export default class RequestsRepositoryBackend implements RequestsRepository {
  constructor(private readonly httpClient: HttpClient) {}

  async getAllRequests(): Promise<RepositoryResult<RequestType[]>> {
    try {
      return RepositoryResultFactory.success(REQUESTS);

      //   const response = await this.httpClient.get<ApiResponse<RequestType[]>>({
      //     url: getRequestsUrl(),
      //     withAuth: true,
      //   });

      //   // Handle the standardized API response
      //   const result = ApiResponseHandler.handleResponse(response);

      //   if (result.success && result.data) {
      //     console.log(
      //       "📋 RequestsRepositoryBackend: Successfully fetched requests",
      //       {
      //         count: result.data.length,
      //       }
      //     );

      //     return RepositoryResultFactory.success(result.data);
      //   } else {
      //     // Return error result with exception information
      //     return RepositoryResultFactory.error(
      //       ApiResponseHandler.createExceptionFromResponse(response)
      //     );
      //   }
    } catch (error) {
      console.error(
        "📋 RequestsRepositoryBackend: Failed to fetch requests",
        error,
      );

      // Return error result with exception information
      return RepositoryResultFactory.error(
        handleRequestError(
          error as ApiResponse<unknown> | HttpException<unknown, unknown>,
        ),
      );
    }
  }

  async filterRequests(
    filters: RequestFilters,
  ): Promise<RepositoryResult<RequestType[]>> {
    try {
      // console.log("📋 RequestsRepositoryBackend: Filtering requests", {
      //   filters,
      // });

      //   const response = await this.httpClient.post<
      //     ApiResponse<RequestType[]>,
      //     RequestFilters
      //   >({
      //     url: filterRequestsUrl(),
      //     body: filters,
      //     withAuth: true,
      //   });

      //   // Handle the standardized API response
      //   const result = ApiResponseHandler.handleResponse(response);

      //   if (result.success && result.data) {
      //     console.log(
      //       "📋 RequestsRepositoryBackend: Successfully filtered requests",
      //       {
      //         count: result.data.length,
      //       }
      //     );

      //     return RepositoryResultFactory.success(result.data);
      //   } else {
      //     // Return error result with exception information
      //     return RepositoryResultFactory.error(
      //       ApiResponseHandler.createExceptionFromResponse(response)
      //     );
      //   }
      const searchLower = (filters.search || "").toLowerCase();
      const filteredRequests = REQUESTS.filter((r) => {
        const matchSearch =
          !searchLower || r.title.toLowerCase().includes(searchLower);
        const matchChannel = filters.channel
          ? r.channels.includes(filters.channel)
          : true;
        // country and segment are placeholders for future data binding
        const matchCountry = !filters.country || filters.country === "ALL";
        const matchSegment = !filters.segment || filters.segment === "ALL";
        return matchSearch && matchChannel && matchCountry && matchSegment;
      });

      return RepositoryResultFactory.success(filteredRequests);
    } catch (error) {
      console.error(
        "📋 RequestsRepositoryBackend: Failed to filter requests",
        error,
      );

      // Return error result with exception information
      return RepositoryResultFactory.error(
        handleRequestError(
          error as ApiResponse<unknown> | HttpException<unknown, unknown>,
        ),
      );
    }
  }

  async getSegments(): Promise<
    RepositoryResult<{ code: string; label: string }[]>
  > {
    try {
      // console.log("📋 RequestsRepositoryBackend: Fetching segments");

      //   const response = await this.httpClient.get<
      //     ApiResponse<{ code: string; label: string }[]>
      //   >({
      //     url: getSegmentsUrl(),
      //     withAuth: true,
      //   });

      //   // Handle the standardized API response
      //   const result = ApiResponseHandler.handleResponse(response);

      //   if (result.success && result.data) {
      //     console.log(
      //       "📋 RequestsRepositoryBackend: Successfully fetched segments",
      //       {
      //         count: result.data.length,
      //       }
      //     );

      //     return RepositoryResultFactory.success(result.data);
      //   } else {
      //     // Return error result with exception information
      //     return RepositoryResultFactory.error(
      //       ApiResponseHandler.createExceptionFromResponse(response)
      //     );
      //   }
      return RepositoryResultFactory.success(SEGMENTS);
    } catch (error) {
      console.error(
        "📋 RequestsRepositoryBackend: Failed to fetch segments",
        error,
      );

      // Return error result with exception information
      return RepositoryResultFactory.error(
        handleRequestError(
          error as ApiResponse<unknown> | HttpException<unknown, unknown>,
        ),
      );
    }
  }

  async createProspect(
    request: CreateProspectRequest,
  ): Promise<RepositoryResult<CreateProspectResponse>> {
    // Transform internal format to API format
    const apiRequest: ApiCreateProspectRequest =
      ProspectDataMapper.toApiRequest(request);

    // Le corps de la reponse depend du segment (CustomerController#createProspect, cote back) :
    // PP renvoie la seule cle metier en chaine (retrocompatibilite) ; PM renvoie un objet enrichi
    // ProspectCreateResponse dont businessKey n'est qu'un champ parmi d'autres. Bug trouve en
    // rejouant la soumission PM reelle jusqu'au bout : le FE supposait une chaine dans les deux cas.
    return executeRequest(
      () =>
        this.httpClient.post<
          ApiResponse<string | ApiProspectCreateResponse>,
          ApiProspectRequest
        >({
          url: createProspectUrl(),
          body: apiRequest,
          withAuth: true,
        }),
      (data) => ({
        success: true,
        businessKey: typeof data === "string" ? data : data.businessKey,
        error: undefined,
      }),
    );
  }

  async getIncorporationCountries(): Promise<
    RepositoryResult<ReferenceOption[]>
  > {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<ApiCountriesPage>>({
          url: incorporationCountriesUrl(),
          withAuth: true,
        }),
      (page) =>
        (page.items ?? [])
          .filter(
            (c): c is ApiCountryItem & { codeBni: string } => !!c.codeBni,
          )
          .map((c) => ({ code: c.codeBni, label: c.nom ?? c.codeBni })),
    );
  }

  async getLegalFormsForCountry(
    countryCode: string,
  ): Promise<RepositoryResult<PmCountryEligibility>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<ApiPmCountryEligibility>>({
          url: legalFormsForCountryUrl(countryCode),
          withAuth: true,
        }),
      (data) => ({
        countryCode: data.countryCode,
        available: data.available,
        reason: data.reason,
        message: data.message,
        legalForms: (data.legalForms ?? []).map((f) => ({
          code: f.code,
          label: f.libelle,
        })),
      }),
    );
  }

  async generateAccess(
    businessKey: string,
  ): Promise<RepositoryResult<GenerateAccessResponse>> {
    return executeRequest(
      () =>
        this.httpClient.post<ApiResponse<GenerateAccessResponse>, null>({
          url: generateAccessUrl(businessKey),
          body: null,
          withAuth: true,
        }),
      (data) => data,
    );
  }
}
